import styled, { css } from "styled-components";
import { theme as toyotaTheme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";

const WIDTH = 40;
const MARGIN = 10;
const ARROW_OFFSET = 40;
const RING_OFFSET = 5;
export const TOTAL_WIDTH = WIDTH + MARGIN * 3;

type ExteriorImageType = {
    image?: string;
    rgb?: string;
    isSelected?: boolean;
    zoomedIn: boolean;
    lightColour: boolean;
};

export const ExteriorImage = styled.div<ExteriorImageType>`
    position: relative;
    top: 0;
    width: ${WIDTH}px;
    height: ${WIDTH}px;
    margin: 0 ${MARGIN}px;
    background-color: transparent;
    border-radius: 50%;
    ${({ image, zoomedIn }) =>
        image &&
        css`
            background-image: url(${image});
            background-position: center;
            background-size: ${!zoomedIn ? "100%" : "45px"};
        `};
    ${({ rgb, image }) =>
        rgb &&
        !image &&
        css`
            background-color: ${`#${rgb.substr(0, 2) === "0x" ? rgb.substr(2) : rgb}`};
        `};

    &::before {
        position: absolute;
        top: -${RING_OFFSET}px;
        left: -${RING_OFFSET}px;
        width: calc(100% + ${RING_OFFSET * 2}px);
        height: calc(100% + ${RING_OFFSET * 2}px);
        content: "";
        border: 1px solid transparent;
        border-color: ${({ isSelected }) => (isSelected ? toyotaTheme.colors.grey4 : "transparent")};
        border-radius: 50%;
        transition: border-color 0.3s;
    }
`;

export const ItemWrapper = styled.button<{ showDivider?: boolean }>`
    ${({ showDivider }) =>
        showDivider &&
        css`
            position: relative;
            &::before {
                display: block;
                position: absolute;
                top: calc(50% - 12px);
                left: 0px;
                width: 1px;
                height: 24px;
                content: "";
                background-color: ${toyotaTheme.colors.grey3};
                box-sizing: border-box;
            }

            html[dir="rtl"] & {
                &::before {
                    left: auto;
                    right: 0px;
                }
            }
        `};
`;

export const Wrapper = styled.div`
    position: relative;
    left: -${MARGIN / 2}px;
`;

export const Slider = styled.div`
    flex: 1;
    overflow: hidden;
    user-select: none;
`;

export const SliderViewport = styled.div<{ rightArrowVisible?: boolean }>`
    display: flex;
    position: relative;
    align-items: center;
    width: calc(100% - ${({ rightArrowVisible }) => (rightArrowVisible ? ARROW_OFFSET : 0)}px);
    height: 60px;
    overflow: hidden;

    @media ${getBreakpoint("down", "lg")} {
        width: 100%;
    }
`;

export const Track = styled.div<{ width?: number; enableTransition?: boolean }>`
    display: flex;
    position: absolute;
    top: 0px; /* This might seem like a unnecessary property, but our friend IE11 thinks this is very important */
    flex-direction: row;
    align-items: center;
    width: ${({ width }) => (width !== undefined ? `${width}px` : "initial")};
    height: 100%;
    ${({ enableTransition }) =>
        enableTransition &&
        css`
            transition:
                left 0.5s,
                right 0.5s;
        `};
`;

export const SliderButton = styled.button<{ alignment: string; show?: boolean }>`
    position: absolute;
    top: calc(50% - ${WIDTH / 2}px);
    width: ${WIDTH}px;
    height: ${WIDTH}px;
    margin: 0;
    padding: 0;
    background-color: transparent;
    border: 0;
    ${({ show }) =>
        !show &&
        css`
            visibility: hidden;
        `};
    ${({ alignment, theme }) =>
        alignment === "left"
            ? css`
                  ${alignment}: ${theme.isRTL ? 0 : "-30px"};
              `
            : css`
                  ${alignment}: ${theme.isRTL ? `-${ARROW_OFFSET}px` : 0};
              `};

    @media ${getBreakpoint("down", "lg")} {
        display: none;
    }
`;
